
// import am4lang_fr_FR from "@/translations/amchart/fr_FR";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Component } from "vue-property-decorator";
import BaseInternalChartValorization from "@/components/pages/valorizations/internal/observatory/BaseInternalChartValorization.vue";

am4core.useTheme(am4themes_animated);

@Component
export default class AnnualCumulativeNumberChart extends BaseInternalChartValorization {
  protected groups = {
    amphibian: {
      label: "Amphibiens",
      name: "amphibian"
    },

    chiropteres: {
      label: "Chiroptères",
      name: "chiropteres"
    },

    coleopteres: {
      label: "Coléoptères",
      name: "coleopteres"
    },

    lepidopteres: {
      label: "Lépidoptères",
      name: "lepidopteres"
    },

    mammiferes_hors_chiro: {
      label: "Mammifères terrestres",
      name: "mammiferes_hors_chiro"
    },

    reptiles: {
      label: "Reptiles",
      name: "reptiles"
    },

    odonates: {
      label: "Odonates",
      name: "odonates"
    },

    orthopteres: {
      label: "Orthoptères",
      name: "orthopteres"
    },

    avifaune: {
      label: "Oiseaux",
      name: "avifaune"
    },

    all: {
      label: "Tous groupes faunistiques",
      name: "all"
    }
  };
  protected title = "Nombre annuel cumulé";
  protected subTitle = "Observatoire Faune";
  protected description = "";
  protected url = "/valorization/observatory/fauna/annual-cumulative-number";

  drawData() {
    function am4themes_myTheme(target) {
      if (target instanceof am4core.ColorSet) {
        target.list = [
          am4core.color("#0c802d"),
          am4core.color("#99b036"),
          am4core.color("#ffd540"),
          am4core.color("#ffc000"),
          am4core.color("#d09e00"),
          am4core.color("#99802d")
        ];
      }
    }

    am4core.useTheme(am4themes_myTheme);

    let vm = this;
    let count = 0;
    this.data.forEach(
      item =>
        (count += Object.values(item).reduce(
          (prev, cur) => prev + (typeof cur === "number" ? cur : 0),
          0
        ))
    );

    this.data = count > 0 ? this.data : [];

    this.chart = am4core.create(this.$refs.chart, am4charts.XYChart);
    // this.chart = am4core.create(this.$refs.chart, am4charts.XYChart3D);
    this.chart.hiddenState.properties.opacity = 0;
    // this.chart.language.locale = am4lang_fr_FR;

    this.chart.data = this.data;

    this.chart.exporting.menu = new am4core.ExportMenu();
    this.chart.exporting.filePrefix = this.subTitle + " - " + this.title;

    // this.chart.colors.step = 2;

    this.chart.legend = new am4charts.Legend();
    this.chart.legend.parent = this.chart.chartContainer;
    // this.chart.legend.background.fill = am4core.color("#000");
    // this.chart.legend.background.fillOpacity = 0.05;
    // this.chart.legend.width = 100;
    this.chart.legend.position = "top";
    this.chart.legend.align = "right";
    this.chart.legend.padding(10, 15, 10, 15);
    // this.chart.legend.itemContainers.template.clickable = false;
    // this.chart.legend.itemContainers.template.focusable = false;
    //
    // var legendTitle = legend.createChild(am4core.Label);
    // legendTitle.text = "Member since:";

    // Round all numbers to integer
    // this.chart.numberFormatter.numberFormat = "# ###";

    let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "name";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.rotation = 325;
    categoryAxis.renderer.labels.text = "label";

    let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.minWidth = 35;

    for (let year in this.data[0]) {
      if (year !== "name" && year !== "label") {
        let series = this.chart.series.push(new am4charts.ConeSeries());
        if (1 === this.data.length)
          series.columns.template.width = am4core.percent(50);
        series.columns.template.tooltipText = "{label}: {valueY.value}";
        series.name = year;
        series.dataFields.categoryX = "name";
        series.dataFields.valueY = year;
        // series.stacked = true;

        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{valueY}";
        valueLabel.label.fontSize = 8;
        valueLabel.label.dy = -10;
        valueLabel.label.truncate = false;
        valueLabel.label.hideOversized = false;
        this.chart.maskBullets = false;
      }
    }

    // // Add scrollbars
    // this.chart.scrollbarX = new am4core.Scrollbar();
    // this.chart.scrollbarY = new am4core.Scrollbar();
    //
    // // Add cursor
    // this.chart.cursor = new am4charts.XYCursor();
    // this.chart.cursor.behavior = "zoomXY";
  }

  mounted() {
    this.params = {
      station: this.stationProp,
      startDate: this.startDateProp,
      endDate: this.endDateProp
    };

    this.loadData();
  }
}
